import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { ChevronLeft } from 'lucide-react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';

const Privacy = () => {
  const [content, setContent] = useState<string>('');
  const [lastUpdated, setLastUpdated] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('key, value')
          .in('key', ['privacy_content', 'privacy_last_updated']);

        if (error) throw error;

        const contentVal = data?.find(i => i.key === 'privacy_content')?.value || '';
        const dateVal = data?.find(i => i.key === 'privacy_last_updated')?.value || 'ינואר 2024';

        setContent(contentVal);
        setLastUpdated(dateVal);
      } catch (e) {
        console.error('Failed to load privacy content', e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <main className="pt-4 lg:pt-16 pb-12">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Breadcrumbs */}
          <div className="mb-6" dir="rtl">
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink href="/" className="text-muted-foreground hover:text-foreground">
                    בית
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator>
                  <ChevronLeft className="h-4 w-4" />
                </BreadcrumbSeparator>
                <BreadcrumbItem>
                  <BreadcrumbPage>מדיניות פרטיות</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-foreground mb-4">מדיניות פרטיות</h1>
            <p className="text-muted-foreground">עדכון אחרון: {lastUpdated}</p>
          </div>

          <div className="space-y-8" dir="rtl">
            {loading ? (
              <div className="flex justify-center p-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              </div>
            ) : content ? (
              <div className="space-y-6">
                {content.split(/\n\s*\n/).map((section, index) => {
                  if (!section.trim()) return null;
                  return (
                    <Card key={index}>
                      <CardContent className="prose prose-gray max-w-none text-right pt-6">
                        <div className="whitespace-pre-line font-sans text-lg leading-relaxed">
                          {section}
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            ) : (
              <Card>
                <CardContent className="p-8 text-center text-muted-foreground">
                  טרם הוזן תוכן למדיניות הפרטיות.
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;